module.exports = __webpack_public_path__ + "files/964440572eca909f46b97e959538209c.png";